import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of } from 'rxjs';
import { catchError, filter, startWith, switchMap } from 'rxjs/operators';
import * as version from '../../mif/environments/versions';
import { AdminAuthService } from './auth/admin-auth.service';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'app-root-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  constructor(private adminAuthService: AdminAuthService, private router: Router) {}

  @ViewChild('sidenav') sidenav: MatSidenav;
  isShowing = false;
  isLoggedIn = false;

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null),
      switchMap(() => this.adminAuthService.isAuthenticated().pipe(
        startWith(false),
        catchError(() => of(false))
      )),
      untilDestroyed(this)
    ).subscribe(isAuthenticated => {
      this.isLoggedIn = isAuthenticated;
    });
    console.log('version: ' + JSON.stringify(version));
  }

  mouseenter(): void {
    this.isShowing = true;
  }

  mouseleave(): void {
    this.isShowing = false;
  }

  isSidebarCollapsed = false;

  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  menuItems: MenuItem[] = [
    {
      icon: 'dashboard',
      label: 'Accueil',
      link: 'home'
      // isOpen: false
      // children: [
      //   { icon: 'fas fa-chart-pie', label: 'Analytics' },
      //   { icon: 'fas fa-tasks', label: 'Projects' }
      // ]
    },
    {
      icon: 'build',
      label: 'Maintenance',
      link: 'maintenance'
    },
    {
      icon: 'list_alt',
      label: 'Libellés',
      link: 'labels'
    },
    {
      icon: 'local_offer',
      label: 'Offres promotionnelles',
      link: 'offers'
    },
    {
      icon: 'notifications',
      label: 'Notifications email',
      link: 'emails'
    },
    {
      icon: 'settings',
      label: 'Paramètres',
      link: 'settings'
    },
    {
      icon: 'subject',
      label: 'Offre GPA',
      link: 'gpa-in-cems'
    },
    {
      icon: 'assessment',
      label: 'Performance passée',
      link: 'performance'
    },
    {
      icon: 'cancel_presentation',
      label: 'Abandons de souscription',
      link: 'subscription-abandonments'
    },
    {
      icon: 'exit_to_app',
      label: 'Se déconnecter',
      link: '/authentication/logout'
    }
  ];

  toggleSidebar() {
    this.onSidebarToggle();
  }

  toggleMenuItem(item: MenuItem) {
    // Only toggle if sidebar is not collapsed and item has children
    if (!this.isSidebarCollapsed && item.children) {
      item.isOpen = !item.isOpen;
    }
  }
}

interface MenuItem {
  icon: string;
  link: string;
  label: string;
  children?: MenuItem[];
  isOpen?: boolean;
}
